import React, { forwardRef, useEffect, useState } from 'react';
import { ProfileImageView } from 'src/app/components';
import LocalImages from '../../static';
import { CommonMessageListItemType } from 'src/shared/types/src';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'src/app/navigation/routes';
import { CommunicationActions } from 'src/shared/redux-state/src/lib/messages/communication/CommunicationSlice';
import { useAppDispatch } from 'src/app/services/store';

type CommunicationItemProps = {
  message: CommonMessageListItemType;
};

const CommunicationItem = forwardRef<HTMLDivElement, CommunicationItemProps>(({ message }, ref) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [displayMessage, setDisplayMessage] = useState<string>('');

  useEffect(() => {
    const msg = message?.directParticipant &&
      message?.directParticipant?.name &&
      message?.directParticipant?.name?.length
      ? `${message?.directParticipant?.name}: ${message?.lastMessage?.content}`
      : message?.lastMessage?.content
    setDisplayMessage(msg || '');
  }, [message]);

  const onCommunicationClick = () => {
    navigate(`${AppRoutes.COMMUNICATIONS}/${message.id}`);
    dispatch(CommunicationActions.updateReadStatus({ id: parseInt(message.id) }))
  }

  return (
    <div className='message-item-wrapper cursor-pointer' ref={ref} onClick={onCommunicationClick}>
      <div className={`message-item ${message.isRead ? '' : 'unread'}`}>
        {
          message?.photo ?
            <>
              <ProfileImageView
                name={message?.directParticipant?.name}
                imageUrl={message.photo}
              />
            </> :
            <>
              <div className='avatar-icon'>
                <img src={LocalImages.emailIcon} alt="email-icon" />
              </div>
            </>
        }
        <div className='message-item-left flex-1'>
          <div className='message-title'>
            <div className='message-name'>{message.title}</div>
            {message?.messageType === 'sent' && <span>Sent</span>}
          </div>
          {
            !!displayMessage && !message.isLastMessageDeleted &&
            <div className='message-description'>{displayMessage}</div>
          }
          {(displayMessage && message.isLastMessageDeleted) && <div className='message-description'>{displayMessage}</div>}
          {!displayMessage && <div className='message-description'>No messages</div>}

        </div>
        <div className='message-item-right'>
          <div className='message-time'>{message.lastMessage?.timestamp}</div>
          {
            (!!message.unReadCount && !isNaN(message.unReadCount) && message.unReadCount > 0)
            && <div className='message-count'>{message.unReadCount}</div>
          }
          {message.hasAttachments && <div className='message-icon'>
            <img src={LocalImages.attachmentIcon} alt="message-icon" />
          </div>}
        </div>
      </div>
    </div>
  );
});

export default CommunicationItem;
